import { render, staticRenderFns } from "./NewOctoPrintTunnelPage.vue?vue&type=template&id=bef1eb78&scoped=true&"
import script from "./NewOctoPrintTunnelPage.vue?vue&type=script&lang=js&"
export * from "./NewOctoPrintTunnelPage.vue?vue&type=script&lang=js&"
import style0 from "./NewOctoPrintTunnelPage.vue?vue&type=style&index=0&id=bef1eb78&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef1eb78",
  null
  
)

export default component.exports